export enum KnowledgeBaseTypes {
  pdf = "PDF",
  video = "MP4"
}
